export const version = "bignumber/5.8.0";
//# sourceMappingURL=_version.js.map